<div class="optional-boolean-select">
  <radio-group [group]="group+groupSuffix"
               name="optional-boolean-radios"
               [items]="allItems"
               [disabled]="disabled"
               [ngModel]="selectedValue"
               (ngModelChange)="onValueChanged($event)"
  ></radio-group>
</div>
